module.exports = __webpack_public_path__ + "img/cszq_partners_8.913dccda.jpg";